import { getHotArticles } from '@/mocks/articles';
import VideoCard from '@/components/feature/VideoCard';

export default function HotContent() {
  const hotArticles = getHotArticles().slice(0, 6);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: hotArticles.map((article, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Article',
        name: article.title,
        url: `https://jiujiu.video/article/${article.id}`,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <section className="py-10 md:py-14 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                热门内容
              </h2>
              <span className="px-2.5 py-1 text-xs bg-primary-100 text-primary-600 rounded-full font-medium">
                实时
              </span>
            </div>
            <a href="/" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1">
              查看全部 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {hotArticles.map((article) => (
              <VideoCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}